export const FINAL_AWARD_ID = "fcCXt3CVpErT99cSz5yw";

export const AWARD_TYPES = {
  NORMAL: "normal",
  SPECIAL: "special",
};

export const SPECIAL_AWARD_DEFINITIONS = [
  {
    key: "tofu-del-ano",
    name: "Tofu del Ano",
    description:
      "Reconoce a quien ha sostenido el nivel mas alto durante toda la edicion: rendimiento, impacto y trayectoria general.",
  },
  {
    key: "tofu-revelacion",
    name: "Tofu Revelacion",
    description:
      "Premia el mayor salto de nivel: quien ha crecido mas, ha ido claramente de menos a mas y ha terminado en otra dimension.",
  },
  {
    key: "tofu-promesa",
    name: "Tofu promesa",
    aliases: ["Promesa de los Tofu"],
    description:
      "Distingue a la figura externa al nucleo principal que mejor ha rendido y mas proyeccion ha dejado alrededor del grupo.",
  },
];

const normalizeLabel = (value = "") =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

export const getSpecialAwardDefinition = (awardOrName) => {
  const awardName =
    typeof awardOrName === "string"
      ? awardOrName
      : awardOrName?.nombre || awardOrName?.name || "";
  const normalizedAwardName = normalizeLabel(awardName);

  return (
    SPECIAL_AWARD_DEFINITIONS.find(
      (definition) =>
        [definition.name, ...(definition.aliases || [])].some(
          (candidateName) => normalizeLabel(candidateName) === normalizedAwardName
        )
    ) || null
  );
};

export const isPremiumNominationAward = (awardOrName) =>
  getSpecialAwardDefinition(awardOrName)?.key === "tofu-promesa";

export const getAwardName = (award) => award?.nombre || award?.name || "Premio";

export const getAwardDescription = (award) =>
  award?.descripcion ||
  award?.description ||
  getSpecialAwardDefinition(award)?.description ||
  "Ordena a tus nominados y guarda tu votacion.";

export const getAwardType = (award, awardId = "") => {
  const rawType = award?.tipo || award?.type;

  if (rawType) {
    return rawType;
  }

  return awardId === FINAL_AWARD_ID ? AWARD_TYPES.SPECIAL : AWARD_TYPES.NORMAL;
};

export const getAwardMaxNominees = (award, awardId = "") => {
  if (awardId === FINAL_AWARD_ID || getAwardType(award, awardId) === AWARD_TYPES.SPECIAL) {
    return Number(award?.maxNominees || award?.capacidadNominados || 12);
  }

  return Number(award?.maxNominees || award?.capacidadNominados || 4);
};

export const isSpecialAward = (award, awardId = "") =>
  awardId === FINAL_AWARD_ID || getAwardType(award, awardId) === AWARD_TYPES.SPECIAL;

export const getNomineeName = (nominee) => nominee?.nombre || nominee?.name || "Nominado";

export const getNomineeImage = (nominee) => nominee?.imageURL || nominee?.imageUrl || "";

export const getNomineeVideo = (nominee) => nominee?.videoURL || nominee?.videoUrl || "";

export const getNomineeExtraImage = (nominee) =>
  nominee?.mediaUrl || nominee?.mediaURL || nominee?.mediaImageURL || nominee?.mediaImageUrl || "";

export const sortAwards = (awards) =>
  [...awards].sort((left, right) => {
    const leftSpecial = isSpecialAward(left, left.id);
    const rightSpecial = isSpecialAward(right, right.id);

    if (leftSpecial !== rightSpecial) {
      return leftSpecial ? 1 : -1;
    }

    const leftOrder = Number(left.sortOrder ?? left.orden ?? Number.MAX_SAFE_INTEGER);
    const rightOrder = Number(right.sortOrder ?? right.orden ?? Number.MAX_SAFE_INTEGER);

    if (leftOrder !== rightOrder) {
      return leftOrder - rightOrder;
    }

    return getAwardName(left).localeCompare(getAwardName(right), "es", { sensitivity: "base" });
  });

export const getSpecialAwards = (awards) =>
  sortAwards(awards).filter((award) => isSpecialAward(award, award.id));

export const getVotingAwardIds = (awards) =>
  sortAwards(awards)
    .filter((award) => !isSpecialAward(award, award.id))
    .map((award) => award.id);
